import { render, staticRenderFns } from "./taksTypeTemplate.vue?vue&type=template&id=8daff072&scoped=true"
import script from "./taksTypeTemplate.vue?vue&type=script&lang=js"
export * from "./taksTypeTemplate.vue?vue&type=script&lang=js"
import style0 from "./taksTypeTemplate.vue?vue&type=style&index=0&id=8daff072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daff072",
  null
  
)

export default component.exports